const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="social-links">
          <a href="https://discord.gg/EBXR4SuBCT" target="_blank" rel="noopener noreferrer">
            Discord
          </a>
          <a href="https://havk-hacking-the-desert.devpost.com/" target="_blank" rel="noopener noreferrer">
            Devpost
          </a>
          <a href="https://github.com/hackwithhavk" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <a href="mailto:hackwithhavk@gmail.com">Email</a>
        </div>
        <p>&copy; 2025 HAVK. Fair hackathons for everyone.</p>
        <p>Building transparent opportunities for developers worldwide.</p>
      </div>
    </footer>
  )
}

export default Footer
